import { VaultDisclosuresResponse } from "../../types";
import { useVaultDisclosuresDomain } from "../domain/vault-disclosures";

export function useVaultDisclosures({ vaultAddress }: { vaultAddress: string | undefined }) {
    return useVaultDisclosuresDomain({ vaultAddress });
}

export function hasVaultDisclosures(data: VaultDisclosuresResponse | undefined): boolean {
    return !!data?.disclaimer || !!data?.risks?.length || !!data?.audits?.length || !!data?.documentation?.length;
}
